const SkeletonCartModal = () => {
  return (
    <div className="mb-6 flex animate-pulse items-start border-b pb-4">
      <div className="mr-4">
        <div className="h-[132px] w-[114px] rounded bg-gray-200/20" />
      </div>
      <div className="flex flex-1 flex-col justify-between space-y-2">
        <div className="flex items-center justify-between">
          <div className="h-4 w-40 rounded bg-gray-200/20" />
          <div className="h-4 w-16 rounded bg-gray-200/20" />
        </div>
        <div className="mt-2 flex items-center space-x-2">
          <div className="h-5 w-5 rounded bg-gray-200/20" />
          <div className="h-4 w-12 rounded bg-gray-200/20" />
          <div className="h-5 w-5 rounded bg-gray-200/20" />
        </div>
        <div className="mt-[46px] flex justify-between">
          <div className="h-3 w-16 rounded bg-gray-200/20" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCartModal;
